// @flow

import { observer } from "mobx-react";
import React from "react";

import ImageHelper from "app/util/ImageHelper";

import type { TimelineItemMetaImage } from "app/models/TimelineItem";
import TimelineItem from "app/models/TimelineItem";

import "./UrlTimelineItem.scss";

type Props = {
    item: TimelineItem,
    scale: number
};

@observer
export default class UrlTimelineItem extends React.Component<Props> {
    render() {
        const metaImage = this.props.item.metaImage;
        if (!metaImage) {
            console.warn("UrlTimelineItem: no metaImage set");
            return null;
        }

        if (metaImage.type === "favicon") {
            return this.renderFavicon();
        }

        return this.renderImage();
    }

    renderFavicon() {
        const item = this.props.item;
        const src = this.grabImage(item.metaImage) || "";

        return (
            <div className="UrlTimelineItem">
                <div className="UrlTimelineItem__background" />
                <div className="UrlTimelineItem__mask" />
                <div
                    className="UrlTimelineItem__favicon"
                    style={{ backgroundImage: `url(${src})` }}
                />
            </div>
        );
    }

    renderImage() {
        const item = this.props.item;
        const src = this.grabImage(item.metaImage) || "";

        return (
            <div className="UrlTimelineItem">
                <div
                    className="UrlTimelineItem__image"
                    style={{ backgroundImage: `url(${src})` }}
                />
            </div>
        );
    }

    grabImage(metaImage: ?TimelineItemMetaImage): ?string {
        if (!metaImage) return null;

        if (metaImage.type === "favicon") {
            return metaImage.src;
        }

        return ImageHelper.makeUrl(metaImage.src, "jpg", { width: 100 });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineItem/UrlTimelineItem/UrlTimelineItem.js